import { getDotColor, SolidStatusPill } from '@odo/shared-ui';
import { levelPillStyle, normalizeLevel } from './dmNotificationLevels';

interface NotificationLevelPillProps {
    level: string;
    // Shown before the label ("2 Alert") on the patient row's summary.
    count?: number;
}

export function NotificationLevelPill({ level, count }: NotificationLevelPillProps) {
    const style = levelPillStyle(normalizeLevel(level));
    const label = count === undefined ? style.label : `${count} ${style.label}`;
    return (
        <SolidStatusPill
            value={style.label}
            label={label}
            toneClassName={style.toneClassName}
            dotClassName={getDotColor(style.dotLevel)}
        />
    );
}
